import React from "react";

import Navbar from "@/components/home/Navbar";
import Hero from "@/components/home/Hero";
import LogoCarousel from "@/components/home/LogoCarousel";
import Stats from "@/components/home/Stats";
import DemoShowcase from "@/components/home/DemoShowcase";
import HowItWorks from "@/components/home/HowItWorks";
import Features from "@/components/home/Features";
import WhyNeiv from "@/components/home/WhyNeiv";
import Industries from "@/components/home/Industries";
import BeforeAfter from "@/components/home/BeforeAfter";
import Testimonial from "@/components/home/Testimonial";
import FAQ from "@/components/home/FAQ";
import FinalCTA from "@/components/home/FinalCTA";
import Footer from "@/components/home/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white text-neutral-900">
      <Navbar />
      <main>
        <Hero />
        <LogoCarousel />
        <Stats />
        <DemoShowcase />
        <HowItWorks />
        <Features />
        <WhyNeiv />
        <Industries />
        <BeforeAfter />
        <Testimonial />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
